import React from 'react'
import { func, string, bool } from 'prop-types'
import { Button, Message } from '@cobalt/cobalt-react-components'
import {
  PASSWORD_SETTINGS_TITLE,
  PASSWORD_SETTINGS_LOCAL_LOGIN_DISABLED,
  PASSWORD_CHANGE_TITLE,
  GENERIC_SERVER_ERROR
} from '../../constants/ui.labels'
import SettingItem from '../Settings/SettingItem'
import mapError from '../../utils/mapError/userManagement'
import ToastError from '../ToastError'

class PasswordSettings extends React.PureComponent {
  state = { toastError: null }

  componentDidUpdate(previousProps) {
    if (this.props.errorCode && !previousProps.errorCode) {
      this.setState({ toastError: this.createToastError() })
    }
  }

  handleChangePassword = () => {
    this.props.goToChangePasswordPage()
  }

  renderActionButton = () => {
    const { isPasswordSetupInProgress, isLocalLoginEnabled } = this.props
    const state = isPasswordSetupInProgress ? Button.LOADING_STATE : null
    return (
      <Button
        primary
        inverted
        small
        state={state}
        onClick={this.handleChangePassword}
        disabled={!isLocalLoginEnabled || isPasswordSetupInProgress}
      >
        {PASSWORD_CHANGE_TITLE}
      </Button>
    )
  }

  createToastError = () => (
    <ToastError
      title={mapError(this.props.errorCode, GENERIC_SERVER_ERROR)}
      onDismiss={this.dismissToastError}
    />
  )

  dismissToastError = () => this.setState({ toastError: null })

  renderPasswordDisabledWarning = () => (
    <Message warning>{PASSWORD_SETTINGS_LOCAL_LOGIN_DISABLED}</Message>
  )

  render = () => (
    <React.Fragment>
      <SettingItem
        title={PASSWORD_SETTINGS_TITLE}
        actionButton={this.renderActionButton()}
      >
        {!this.props.isLocalLoginEnabled &&
          this.renderPasswordDisabledWarning()}
      </SettingItem>
      {this.state.toastError}
    </React.Fragment>
  )
}

PasswordSettings.propTypes = {
  goToChangePasswordPage: func.isRequired,
  isLocalLoginEnabled: bool.isRequired,
  isPasswordSetupInProgress: bool,
  errorCode: string
}

export default PasswordSettings
